
import { read, utils } from 'xlsx'

export default {
    load(file, columnNames, valueConvert) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader()
            reader.onload = function (e) {
                var workbook = null
                try {
                    workbook = read(e.target.result, { type: 'binary' })
                } catch (e) {
                    reject(e)
                    return
                }
                if (workbook) {
                    if (workbook.SheetNames.length <= 0) {
                        reject(new Error('read sheet count is 0'))
                        return
                    }

                    var json = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
                    var result = []
                    for (var item of json) {
                        var temp = {}
                        for (var key in columnNames) {
                            if (valueConvert && typeof valueConvert[columnNames[key]] == 'function') {
                                temp[columnNames[key]] = valueConvert[columnNames[key]](item[key])
                            } else {
                                temp[columnNames[key]] = item[key]
                            }

                            //默认去除首尾不可见字符
                            if (temp[columnNames[key]] && temp[columnNames[key]].trim) {
                                temp[columnNames[key]] = temp[columnNames[key]].trim()
                            }
                        }
                        result.push(temp)
                    }
                    resolve(result)
                }

            }
            reader.onerror = reject
            reader.readAsBinaryString(file)
        })

    }
}